import React from 'react';
import { Modal } from 'antd';
import '../../../src/components/alert/style/alert.scss';
import debounce from 'lodash/debounce';

const confirmProps = {
  cancelText: 'Cancel',
  okText: 'Delete',
  content: 'Do you confirm to delete this item?',
  cancelButtonProps: {
    className: 'cancel-btn',
  },
  maskClosable: true,
};
const customConfirm = (
  customContent,
  customOK = 'Delete',
  customCancel = 'Cancel',
) => ({
  cancelText: customCancel,
  okText: customOK,
  content: customContent,
  cancelButtonProps: {
    className: 'cancel-btn',
  },
  maskClosable: true,
});
const confirmWithSaveProps = {
  className: 'alert-warning-save',
  content: 'Please save your changes before you leaving the page.',
  okText: 'Save',
};
const confirmNotSaveProps = {
  className: 'alert-warning-save',
  content: 'Do you want to cancel all the changes?',
  okText: 'Yes',
};
const alertBox = (content, type) => {
  if (content.className) {
    content.customizedClassName = content.className;
    delete content.className;
  }
  if (typeof content === 'string') {
    content = { content };
  }
  if (type === 'confirmWithSave') {
    content = { ...confirmWithSaveProps, ...content };
  }
  if (type === 'confirmWithNoSave') {
    content = { ...confirmNotSaveProps, ...content };
  }
  if (type === 'confirm') {
    content = { ...confirmProps, ...content };
  }
  if (type === 'customConfirm') {
    content = {
      ...customConfirm(
        content.customContent,
        content.customOK,
        content.customCancel,
      ),
      ...content,
    };
  }

  if (content.className || content.customizedClassName) {
    content.className = `alert-box ${content.className || ''} ${
      content.customizedClassName || ''
    }`;
  }

  return Modal[
    type === 'confirmWithSave' ||
    type === 'confirmWithNoSave' ||
    type === 'customConfirm'
      ? 'confirm'
      : type
  ]({
    closable: true,
    icon: (
      <span
        className={`${
          type === 'confirm' ||
          type === 'confirmWithSave' ||
          type === 'confirmWithNoSave' ||
          type === 'customConfirm'
            ? 'warning'
            : type
        }-badge`}
      >
        {type === 'error' ? 'ERROR' : type === 'success' ? '' : 'WARNING'}
      </span>
    ),
    className: `alert-box ${content.async ? 'async' : ''}`,
    okText: 'Ok',
    ...content,
  });
};

export default debounce(alertBox, 600);
